import React from 'react';
import cn from 'clsx';

import {
  CircleHalfStrokeRegularIcon,
  CircleRegularIcon,
  CircleSolidIcon
} from '../../shared/icons/icons';

import styles from './circles-rating.scss';

export enum FilledCircleColor {
  BLUE = 'blue',
  GOLD = 'gold',
  GREY = 'grey',
  SLATE = 'slate'
}

interface CirclesRatingProps {
  className?: string;
  filledCircleColor?: FilledCircleColor;
  outOf?: number;
  rating?: number;
}

function CirclesRating(props: CirclesRatingProps) {
  const {
    className = '',
    filledCircleColor = FilledCircleColor.GREY,
    outOf = 5,
    rating = 0
  } = props;

  let formattedRating: string | number = 0;

  if (rating && !isNaN(rating)) {
    formattedRating = Number.isInteger(rating) ? rating : rating?.toFixed(1);
  }

  let formatRating: number =
    typeof formattedRating === 'string'
      ? Number(formattedRating)
      : formattedRating;

  const ratingFloor = Math.floor(formatRating);
  const ratingCeil = Math.ceil(formatRating);

  return (
    <div
      className={cn(styles['container'], `${className || ''} circles-rating`)}
    >
      {Array.from({ length: outOf }, (_, idx) => {
        let circle;
        if (idx < ratingFloor) {
          circle = <CircleSolidIcon className={styles[filledCircleColor]} />;
        } else if (idx < ratingCeil) {
          circle = (
            <CircleHalfStrokeRegularIcon
              className={styles[filledCircleColor]}
            />
          );
        } else {
          circle = <CircleRegularIcon className={styles[filledCircleColor]} />;
        }

        return (
          <span className={styles['circle-wrapper']} key={idx}>
            {circle}
            <CircleSolidIcon className={styles['circle-empty']} />
          </span>
        );
      })}
    </div>
  );
}

export default React.memo(CirclesRating);
